module.exports = __webpack_public_path__ + "img/underline-02.b6712e8e.svg";